import ViverseButton, { ViverseButtonVariants } from '@/components/ViverseButton'
import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { ReactNode, useEffect } from 'react'

type TYPE = 'default' | 'viverse' | 'custom'

type AlertDialogProps = {
  open: boolean
  type?: TYPE
  overlay?: boolean
  titleIcon?: ReactNode
  title?: string
  description?: string
  cancelText?: string
  actionText?: string
  onCancel?: () => void
  onAction?: () => void
  cancelButtonClassName?: string
  actionButtonClassName?: string
  allowOutsideInteraction?: boolean
}

const BUTTON_VARIANT: Record<
  TYPE,
  { cancel: ViverseButtonVariants; action: ViverseButtonVariants }
> = {
  default: {
    cancel: 'secondary',
    action: 'default',
  },
  viverse: {
    cancel: 'outline',
    action: 'colorful',
  },
  custom: {
    cancel: 'custom',
    action: 'custom',
  },
}

export default function DefaultAlertDialog({
  open = false,
  type = 'default' as TYPE,
  overlay = true,
  titleIcon,
  title = 'Alert',
  description = 'This is an alert dialog. Please take action.',
  cancelText = 'Cancel',
  actionText = 'Action',
  cancelButtonClassName,
  actionButtonClassName,
  onCancel,
  onAction,
  allowOutsideInteraction = false,
}: AlertDialogProps) {
  useEffect(() => {
    if (allowOutsideInteraction) {
      document.body.style.pointerEvents = 'auto'
    }
  })
  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Portal>
        {overlay && <AlertDialog.Overlay className="fixed inset-0 z-50 bg-[#000000B2]" />}
        <AlertDialog.Content className="bg-vive-surface-normal backdrop-blur-[50px]-translate-x-1/2 xs:min-w-[312px] xs:min-w-none fixed top-1/2 left-1/2 z-50 flex h-fit w-fit min-w-[calc(100%-48px)] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-6 overflow-auto rounded-[7px] px-6 py-6 shadow-md md:max-h-[504px] md:min-h-[216px] md:max-w-[640px] md:min-w-[420px] md:gap-8 md:px-10 md:py-8">
          <div className="flex flex-col items-center gap-2 md:gap-4">
            <div className="flex flex-col items-center gap-2">
              {titleIcon}
              <AlertDialog.Title
                asChild
                className="text-vive-white header2-omni-styles truncate text-center"
              >
                <p>{title}</p>
              </AlertDialog.Title>
            </div>
            <AlertDialog.Description className="body1-omni-styles text-vive-primary-20">
              {description}
            </AlertDialog.Description>
          </div>
          <div className="flex w-full flex-wrap justify-center gap-4">
            {onCancel && (
              <ViverseButton
                className={cancelButtonClassName}
                variant={BUTTON_VARIANT[type].cancel}
                size={'medium'}
                onClick={onCancel}
              >
                {cancelText}
              </ViverseButton>
            )}
            {onAction && (
              <ViverseButton
                className={actionButtonClassName}
                variant={BUTTON_VARIANT[type].action}
                size={'medium'} //colorful
                onClick={onAction}
              >
                {actionText}
              </ViverseButton>
            )}
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
